import React, { useState, useEffect } from 'react';
import PersonelKartiPage from './PersonelKartiPage';
import axios from 'axios';

const fmt = (t) => t ? new Date(t).toLocaleDateString('tr-TR') : '-';
const fmtPara = (v, pb = 'TRY') => v ? Number(v).toLocaleString('tr-TR') + ' ' + pb : '-';

const DURUM_RENK = {
  bekliyor: { bg: '#F3F4F6', text: '#6B7280', label: 'Bekliyor' },
  hr_onayinda: { bg: '#EEF2FF', text: '#4F46E5', label: 'HR Onayinda' },
  yonetim_onayinda: { bg: '#FEF3C7', text: '#D97706', label: 'Yonetim Onayinda' },
  onaylandi: { bg: '#D1FAE5', text: '#059669', label: 'Onaylandi' },
  reddedildi: { bg: '#FEE2E2', text: '#DC2626', label: 'Reddedildi' },
  iptal: { bg: '#F3F4F6', text: '#9CA3AF', label: 'Iptal' },
};

const ONCELIK_RENK = {
  dusuk: { bg: '#F3F4F6', text: '#6B7280', label: 'Dusuk' },
  normal: { bg: '#EEF2FF', text: '#4F46E5', label: 'Normal' },
  yuksek: { bg: '#FEF3C7', text: '#D97706', label: 'Yuksek' },
  acil: { bg: '#FEE2E2', text: '#DC2626', label: 'Acil' },
};

const KadroSekme = ({ musteriId }) => {
  const [talepler, setTalepler] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(true);

  useEffect(() => {
    axios.get('/api/kadro')
      .then(r => {
        setTalepler(r.data.filter(t => String(t.musteri_id) === String(musteriId)));
        setYukleniyor(false);
      })
      .catch(() => setYukleniyor(false));
  }, [musteriId]);

  if (yukleniyor) return <div style={{ padding: '2rem', color: 'var(--yazi-ikincil)' }}>Yukleniyor...</div>;

  if (talepler.length === 0) return (
    <div className="card" style={{ padding: '3rem', textAlign: 'center', color: 'var(--yazi-ikincil)' }}>
      <div style={{ fontSize: '32px', marginBottom: '8px' }}>📋</div>
      Bu musteri icin kadro talebi bulunamadi.
    </div>
  );

  return (
    <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
      <div className="tablo-wrapper">
        <table>
          <thead>
            <tr>
              <th>Talep</th>
              <th>Pozisyon</th>
              <th>Adet</th>
              <th>Oncelik</th>
              <th>Durum</th>
              <th>Olusturan</th>
              <th>Tarih</th>
            </tr>
          </thead>
          <tbody>
            {talepler.map(t => {
              const d = DURUM_RENK[t.durum] || { bg: '#F3F4F6', text: '#6B7280', label: t.durum };
              const o = ONCELIK_RENK[t.oncelik] || { bg: '#F3F4F6', text: '#6B7280', label: t.oncelik };
              return (
                <tr key={t.id}>
                  <td style={{ fontWeight: '500', fontSize: '14px' }}>{t.baslik}</td>
                  <td style={{ fontSize: '13px' }}>{t.pozisyon_adi || '-'}</td>
                  <td style={{ fontSize: '13px', textAlign: 'center' }}>{t.adet}</td>
                  <td><span style={{ background: o.bg, color: o.text, padding: '3px 10px', borderRadius: '99px', fontSize: '12px', fontWeight: '600' }}>{o.label}</span></td>
                  <td><span style={{ background: d.bg, color: d.text, padding: '3px 10px', borderRadius: '99px', fontSize: '12px', fontWeight: '600' }}>{d.label}</span></td>
                  <td style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>{t.olusturan_ad || '-'}</td>
                  <td style={{ fontSize: '12px', color: 'var(--yazi-ikincil)' }}>{t.olusturma_tarihi ? new Date(t.olusturma_tarihi).toLocaleDateString('tr-TR') : '-'}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const PersonellerSekme = ({ musteriId, personeller, yukle, setSonuc, onPersonelTikla, paraBirimi }) => {
  const [eklePanel, setEklePanel] = React.useState(false);
  const [eklenebilir, setEklenebilir] = React.useState([]);
  const [secili, setSecili] = React.useState('');
  const [faturaPanel, setFaturaPanel] = React.useState(null);
  const [faturaForm, setFaturaForm] = React.useState({ maas: '', fatura_kalemi: '', kdv_orani: 20, fatura_para_birimi: 'TRY', otomatik_gelir_kaydi: false, ay: '' });
  const [otomatikDonem, setOtomatikDonem] = React.useState('');
  const [otomatikSonuc, setOtomatikSonuc] = React.useState(null);

  const QUARTER_LISTESI = () => {
    const list = [];
    const yil = new Date().getFullYear();
    for (let y = yil; y >= yil - 2; y--) {
      for (let q = 4; q >= 1; q--) {
        list.push({ value: `${y}-Q${q}`, label: `${y} Q${q}` });
      }
    }
    return list;
  };

  const eklenebilirleriYukle = () => {
    axios.get('/api/musteriler/' + musteriId + '/personel-eklenebilir')
      .then(r => setEklenebilir(r.data)).catch(console.error);
  };

  const handleEkle = async () => {
    if (!secili) return;
    try {
      await axios.post('/api/musteriler/' + musteriId + '/personel', { kullanici_id: secili });
      setSonuc({ tip: 'basari', mesaj: 'Personel eklendi.' });
      setEklePanel(false); setSecili(''); yukle();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata olustu.' }); }
  };

  const handleCikar = async (kullaniciId) => {
    if (!window.confirm('Bu personeli musteriden cikarmak istediginize emin misiniz?')) return;
    try {
      await axios.delete('/api/musteriler/' + musteriId + '/personel/' + kullaniciId);
      setSonuc({ tip: 'basari', mesaj: 'Personel cikarildi.' }); yukle();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: 'Cikarilomadi.' }); }
  };

  const faturaAc = (p) => {
    const bugunAy = `${new Date().getFullYear()}-${String(new Date().getMonth()+1).padStart(2,'0')}`;
    setFaturaForm({ maas: p.maas || '', fatura_kalemi: p.fatura_kalemi || '', kdv_orani: p.kdv_orani !== null && p.kdv_orani !== undefined ? p.kdv_orani : 20, fatura_para_birimi: p.fatura_para_birimi || paraBirimi || 'TRY', otomatik_gelir_kaydi: !!p.otomatik_gelir_kaydi, ay: bugunAy });
    setFaturaPanel(p.id);
  };

  const handleFaturaKaydet = async () => {
    if (!faturaForm.fatura_kalemi) {
      setSonuc({ tip: 'hata', mesaj: 'Fatura (KDV Haric) zorunludur.' }); return;
    }
    try {
      await axios.put(`/api/musteriler/${musteriId}/personel/${faturaPanel}/fatura`, faturaForm);
      setSonuc({ tip: 'basari', mesaj: 'Fatura bilgileri guncellendi.' });
      setFaturaPanel(null); yukle();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata.' }); }
  };

  const handleOtomatikKayit = async () => {
    if (!otomatikDonem) { setSonuc({ tip: 'hata', mesaj: 'Lutfen quarter secin.' }); return; }
    try {
      const r = await axios.post(`/api/musteriler/${musteriId}/gelir-otomatik`, { donem: otomatikDonem });
      setOtomatikSonuc(r.data);
      setSonuc({ tip: 'basari', mesaj: `${r.data.personel} personel icin gelir kaydi olusturuldu.` });
      yukle();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata.' }); }
  };

  const kdvliTutar = (p) => p.fatura_kalemi ? p.fatura_kalemi * (1 + (p.kdv_orani || 0) / 100) : null;
  const otomatikVar = personeller.some(p => p.otomatik_gelir_kaydi);

  return (
    <div>
      {otomatikVar && (
        <div style={{ background: '#F0FDF4', border: '1px solid #86EFAC', borderRadius: '10px', padding: '12px 16px', marginBottom: '1rem', display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
          <span style={{ fontSize: '13px', fontWeight: 700, color: '#166534' }}>Otomatik Gelir Kaydi</span>
          <select value={otomatikDonem} onChange={e => setOtomatikDonem(e.target.value)} style={{ width: 'auto', fontSize: '13px' }}>
            <option value="">Quarter secin</option>
            {QUARTER_LISTESI().map(q => <option key={q.value} value={q.value}>{q.label}</option>)}
          </select>
          <button className="btn btn-primary btn-sm" onClick={handleOtomatikKayit} disabled={!otomatikDonem}>Kayit Olustur</button>
          {otomatikSonuc && <span style={{ fontSize: '12px', color: '#166534' }}>{otomatikSonuc.personel} personel - Gelir: {Number(otomatikSonuc.gelir||0).toLocaleString('tr-TR')} - Maliyet: {Number(otomatikSonuc.maliyet||0).toLocaleString('tr-TR')}</span>}
        </div>
      )}
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '1rem' }}>
        <button className="btn btn-primary" onClick={() => { setEklePanel(!eklePanel); eklenebilirleriYukle(); }}>+ Personel Ekle</button>
      </div>
      {eklePanel && (
        <div className="card" style={{ marginBottom: '1rem' }}>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-end' }}>
            <div className="form-group" style={{ flex: 1, margin: 0 }}>
              <label>Personel Secin</label>
              <select value={secili} onChange={e => setSecili(e.target.value)}>
                <option value="">-- Personel secin --</option>
                {eklenebilir.map(p => <option key={p.id} value={p.id}>{p.ad} {p.soyad} {p.pozisyon ? '(' + p.pozisyon + ')' : ''}</option>)}
              </select>
            </div>
            <button className="btn btn-primary" onClick={handleEkle} disabled={!secili}>Ekle</button>
            <button className="btn btn-secondary" onClick={() => setEklePanel(false)}>Iptal</button>
          </div>
        </div>
      )}
      {faturaPanel && (() => {
        const p = personeller.find(x => x.id === faturaPanel);
        if (!p) return null;
        const fk = Number(faturaForm.fatura_kalemi) || 0;
        const maliyet = Number(faturaForm.maas) || 0;
        const kdvT = fk * (Number(faturaForm.kdv_orani) || 0) / 100;
        const kdvDahil = fk + kdvT;
        const kar = fk > 0 && maliyet > 0 ? fk - maliyet : null;
        return (
          <div className="card" style={{ marginBottom: '1rem', borderLeft: '4px solid #F59E0B' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
              <span style={{ fontWeight: 700, fontSize: '14px' }}>{p.ad} {p.soyad} - Maas ve Fatura Bilgileri</span>
              <button className="btn btn-secondary btn-sm" onClick={() => setFaturaPanel(null)}>Kapat</button>
            </div>
            <div className="form-grid">
              <div className="form-group"><label>Isveren Maliyeti / Aylik</label><input type="number" value={faturaForm.maas} onChange={e => setFaturaForm(f => ({...f, maas: e.target.value}))} placeholder="orn: 100000" min="0" /></div>
              <div className="form-group"><label>Fatura (KDV Haric)</label><input type="number" value={faturaForm.fatura_kalemi} onChange={e => setFaturaForm(f => ({...f, fatura_kalemi: e.target.value}))} placeholder="orn: 150000" min="0" /></div>
              <div className="form-group"><label>KDV Orani (%)</label><input type="number" value={faturaForm.kdv_orani} onChange={e => setFaturaForm(f => ({...f, kdv_orani: Number(e.target.value)}))} placeholder="20" min="0" max="100" /></div>
              <div className="form-group"><label>Para Birimi</label>
                <select value={faturaForm.fatura_para_birimi} onChange={e => setFaturaForm(f => ({...f, fatura_para_birimi: e.target.value}))}>
                  <option value="TRY">TRY</option><option value="USD">USD</option><option value="EUR">EUR</option><option value="GBP">GBP</option>
                </select>
              </div>
            </div>
            {(fk > 0 || maliyet > 0) && (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: '8px', margin: '10px 0', background: '#EEF2FF', borderRadius: '8px', padding: '12px' }}>
                <div style={{ textAlign: 'center' }}><div style={{ fontSize: '11px', color: '#6B7280' }}>Fatura (KDV Haric)</div><div style={{ fontSize: '14px', fontWeight: 700, color: '#4F46E5' }}>{fk.toLocaleString('tr-TR')} {faturaForm.fatura_para_birimi}</div></div>
                <div style={{ textAlign: 'center' }}><div style={{ fontSize: '11px', color: '#6B7280' }}>KDV (%{faturaForm.kdv_orani})</div><div style={{ fontSize: '14px', fontWeight: 700, color: '#F59E0B' }}>{kdvT.toLocaleString('tr-TR')} {faturaForm.fatura_para_birimi}</div></div>
                <div style={{ textAlign: 'center' }}><div style={{ fontSize: '11px', color: '#6B7280' }}>Fatura (KDV Dahil)</div><div style={{ fontSize: '14px', fontWeight: 700, color: '#059669' }}>{kdvDahil.toLocaleString('tr-TR')} {faturaForm.fatura_para_birimi}</div></div>
                <div style={{ textAlign: 'center' }}><div style={{ fontSize: '11px', color: '#6B7280' }}>Kar (Fatura-Maliyet)</div><div style={{ fontSize: '14px', fontWeight: 700, color: kar !== null ? (kar >= 0 ? '#059669' : '#DC2626') : '#9CA3AF' }}>{kar !== null ? kar.toLocaleString('tr-TR') + ' ' + faturaForm.fatura_para_birimi : '-'}</div></div>
              </div>
            )}
            <div style={{ display: 'flex', gap: '12px', alignItems: 'center', margin: '10px 0', background: '#F9FAFB', borderRadius: '8px', padding: '10px 14px', flexWrap: 'wrap' }}>
              <div className="form-group" style={{ margin: 0, flex: 1, minWidth: '180px' }}>
                <label style={{ fontSize: '12px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '4px' }}>Kayit Ayi</label>
                <select value={faturaForm.ay} onChange={e => setFaturaForm(f => ({...f, ay: e.target.value}))} style={{ width: '100%', fontSize: '13px' }}>
                  <option value="">-- Ay secin --</option>
                  {(() => {
                    const ayAdlari = ['Ocak','Subat','Mart','Nisan','Mayis','Haziran','Temmuz','Agustos','Eylul','Ekim','Kasim','Aralik'];
                    const list = [];
                    const yil = new Date().getFullYear();
                    for (let y = yil; y >= yil - 1; y--) {
                      for (let m = 12; m >= 1; m--) {
                        const val = `${y}-${String(m).padStart(2,'0')}`;
                        list.push(<option key={val} value={val}>{ayAdlari[m-1]} {y}</option>);
                      }
                    }
                    return list;
                  })()}
                </select>
              </div>
              {faturaForm.ay && (
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '11px', color: '#6B7280' }}>Quarter</div>
                  <div style={{ fontSize: '14px', fontWeight: 700, color: '#4F46E5' }}>
                    {(() => { const [y, m] = faturaForm.ay.split('-'); return `${y}-Q${Math.ceil(parseInt(m)/3)}`; })()}
                  </div>
                </div>
              )}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: '8px 0' }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer', fontSize: '13px', fontWeight: 500 }}>
                <input type="checkbox" checked={faturaForm.otomatik_gelir_kaydi} onChange={e => setFaturaForm(f => ({...f, otomatik_gelir_kaydi: e.target.checked}))} />
                Otomatik gelir/maliyet kaydina dahil et
              </label>
            </div>
            <div style={{ display: 'flex', gap: '8px', marginTop: '1rem' }}>
              <button className="btn btn-primary" onClick={handleFaturaKaydet}>Kaydet</button>
              <button className="btn btn-secondary" onClick={() => setFaturaPanel(null)}>Iptal</button>
            </div>
          </div>
        );
      })()}
      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        {personeller.length === 0 ? (
          <div style={{ padding: '3rem', textAlign: 'center', color: 'var(--yazi-ikincil)' }}>Bu musteride calisan personel bulunmuyor.</div>
        ) : (
          <div className="tablo-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Personel</th><th>Pozisyon</th><th>Isveren Maliyeti</th><th>Fatura (KDV Dahil)</th><th>Kar (KDV Haric - Maliyet)</th><th>Otomatik</th><th></th>
                </tr>
              </thead>
              <tbody>
                {personeller.map(p => {
                  const kdvli = kdvliTutar(p);
                  const kar = p.fatura_kalemi && p.maas ? p.fatura_kalemi - p.maas : null;
                  return (
                    <tr key={p.id}>
                      <td onClick={() => onPersonelTikla && onPersonelTikla(p.id)} style={{ cursor: 'pointer' }}>
                        <div style={{ fontWeight: '500' }}>{p.ad} {p.soyad}</div>
                        <div style={{ fontSize: '12px', color: 'var(--yazi-ikincil)' }}>{p.email}</div>
                      </td>
                      <td style={{ fontSize: '13px' }}>{p.pozisyon || '---'}</td>
                      <td style={{ fontSize: '13px', color: 'var(--kirmizi)' }}>{p.maas ? Number(p.maas).toLocaleString('tr-TR') + ' ' + (p.fatura_para_birimi || 'TRY') : '---'}</td>
                      <td style={{ fontSize: '13px', color: 'var(--yesil)', fontWeight: 600 }}>{kdvli ? Number(kdvli).toLocaleString('tr-TR') + ' ' + (p.fatura_para_birimi || 'TRY') : '---'}</td>
                      <td style={{ fontSize: '13px', fontWeight: 600, color: kar !== null ? (kar >= 0 ? 'var(--yesil)' : 'var(--kirmizi)') : 'var(--yazi-ikincil)' }}>
                        {kar !== null ? Number(kar).toLocaleString('tr-TR') + ' ' + (p.fatura_para_birimi || 'TRY') : '---'}
                      </td>
                      <td style={{ textAlign: 'center' }}>{p.otomatik_gelir_kaydi ? <span style={{ color: 'var(--yesil)', fontSize: '16px' }}>&#10003;</span> : <span style={{ color: 'var(--yazi-ikincil)', fontSize: '13px' }}>---</span>}</td>
                      <td>
                        <div style={{ display: 'flex', gap: '4px' }}>
                          <button className="btn btn-secondary btn-sm" onClick={() => faturaAc(p)}>Fatura</button>
                          <button className="btn btn-danger btn-sm" onClick={() => handleCikar(p.id)}>Cikar</button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

const MusteriDetay = ({ musteriId, geriDon }) => {
  const [veri, setVeri] = useState(null);
  const [sekme, setSekme] = useState('bilgiler');
  const [duzenle, setDuzenle] = useState(false);
  const [form, setForm] = useState({});
  const [kadroForm, setKadroForm] = useState({ pozisyon: '', departman: '', aciklama: '' });
  const [kadroPanel, setKadroPanel] = useState(false);
  const [duzenleKadroId, setDuzenleKadroId] = useState(null);
  const [gelirForm, setGelirForm] = useState({ ay: '', gelir: '', maliyet: '', aciklama: '' });
  const [filtreQuarter, setFiltreQuarter] = useState('');
  const [filtreAy, setFiltreAy] = useState('');
  const [gelirPanel, setGelirPanel] = useState(false);
  const [duzenleGelirId, setDuzenleGelirId] = useState(null);
  const [gelirGorunum, setGelirGorunum] = useState('tablo');
  const [seciliPersonelId, setSeciliPersonelId] = useState(null);
  const [kullanicilar, setKullanicilar] = useState([]);
  const [sonuc, setSonuc] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(false);

  React.useEffect(() => {
    if (musteriId) {
      window.history.replaceState({}, '', '/musteriler/' + musteriId + '/' + sekme);
      document.title = 'Musteri Detay - Valure HR';
    }
  }, [sekme, musteriId]);

  const yukle = () => {
    axios.get('/api/musteriler/' + musteriId).then(r => {
      setVeri(r.data);
      setForm(r.data.musteri);
    }).catch(console.error);
  };

  useEffect(() => { yukle(); }, [musteriId]);
  useEffect(() => {
    axios.get('/api/admin/kullanicilar').then(r => setKullanicilar(r.data)).catch(console.error);
  }, []);

  const handleKaydet = async (e) => {
    e.preventDefault(); setYukleniyor(true); setSonuc(null);
    try {
      await axios.put('/api/musteriler/' + musteriId, form);
      setSonuc({ tip: 'basari', mesaj: 'Musteri bilgileri guncellendi.' });
      setDuzenle(false); yukle();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata olustu.' }); }
    finally { setYukleniyor(false); }
  };

  const handleKadroEkle = async (e) => {
    e.preventDefault(); setYukleniyor(true); setSonuc(null);
    try {
      if (duzenleKadroId) {
        await axios.put('/api/musteriler/' + musteriId + '/kadrolar/' + duzenleKadroId, kadroForm);
        setSonuc({ tip: 'basari', mesaj: 'Pozisyon guncellendi.' });
        setDuzenleKadroId(null);
      } else {
        await axios.post('/api/musteriler/' + musteriId + '/kadrolar', kadroForm);
        setSonuc({ tip: 'basari', mesaj: 'Pozisyon eklendi.' });
      }
      setKadroForm({ pozisyon: '', departman: '', aciklama: '' });
      setKadroPanel(false); yukle();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata olustu.' }); }
    finally { setYukleniyor(false); }
  };

  const QUARTER_LISTESI = () => {
    const list = [];
    const yil = new Date().getFullYear();
    for (let y = yil; y >= yil - 3; y--) {
      for (let q = 4; q >= 1; q--) {
        list.push({ value: `${y}-Q${q}`, label: `${y} Q${q}` });
      }
    }
    return list;
  };

  const AY_LISTESI = () => {
    const ayAdlari = ['Ocak','Subat','Mart','Nisan','Mayis','Haziran','Temmuz','Agustos','Eylul','Ekim','Kasim','Aralik'];
    const list = [];
    const yil = new Date().getFullYear();
    for (let y = yil; y >= yil - 2; y--) {
      for (let m = 12; m >= 1; m--) {
        const val = `${y}-${String(m).padStart(2,'0')}`;
        list.push({ value: val, label: `${ayAdlari[m-1]} ${y}` });
      }
    }
    return list;
  };

  const handleGelirEkle = async (e) => {
    e.preventDefault(); setYukleniyor(true); setSonuc(null);
    try {
      if (duzenleGelirId) {
        await axios.put(`/api/musteriler/${musteriId}/gelir/${duzenleGelirId}`, { ...gelirForm, donem: gelirForm.ay });
        setSonuc({ tip: 'basari', mesaj: 'Gelir guncellendi.' });
        setDuzenleGelirId(null);
      } else {
        await axios.post('/api/musteriler/' + musteriId + '/gelir', { ...gelirForm, donem: gelirForm.ay });
        setSonuc({ tip: 'basari', mesaj: 'Gelir kaydedildi.' });
      }
      setGelirForm({ donem: '', gelir: '', maliyet: '', aciklama: '' });
      setGelirPanel(false); yukle();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata olustu.' }); }
    finally { setYukleniyor(false); }
  };

  const handleGelirDuzenle = (g) => {
    setGelirForm({ ay: g.ay || g.donem || '', gelir: g.gelir || '', maliyet: g.maliyet || '', aciklama: g.aciklama || '' });
    setDuzenleGelirId(g.id);
    setGelirPanel(true);
  };

  const handleGelirSil = async (gelirId) => {
    if (!window.confirm('Bu gelir kaydini silmek istiyor musunuz?')) return;
    try { await axios.delete(`/api/musteriler/${musteriId}/gelir/${gelirId}`); yukle(); }
    catch(err) { setSonuc({ tip: 'hata', mesaj: 'Silinemedi.' }); }
  };

  const handleKadroDurum = async (kadroId, durum) => {
    try { await axios.put('/api/musteriler/' + musteriId + '/kadrolar/' + kadroId, { durum }); yukle(); }
    catch(err) { setSonuc({ tip: 'hata', mesaj: 'Durum guncellenemedi.' }); }
  };

  const handleKadroSil = async (kadroId) => {
    if (!window.confirm('Bu kadroyu silmek istediginize emin misiniz?')) return;
    try { await axios.delete('/api/musteriler/' + musteriId + '/kadrolar/' + kadroId); yukle(); }
    catch(err) { setSonuc({ tip: 'hata', mesaj: 'Silinemedi.' }); }
  };

  if (!veri) return <div style={{ padding: '2rem', color: 'var(--yazi-ikincil)' }}>Yukleniyor...</div>;
  if (seciliPersonelId) return <PersonelKartiPage kullaniciId={seciliPersonelId} geriDon={() => setSeciliPersonelId(null)} />;

  const { musteri, personeller, kadrolar, gelirler = [], aktiviteler = [] } = veri;
  const toplamGelir = gelirler.reduce((t, g) => t + (g.gelir || 0), 0);
  const toplamMaliyet = gelirler.reduce((t, g) => t + (g.maliyet || 0), 0);

  const sekmeler = [
    { key: 'bilgiler', label: 'Bilgiler' },
    { key: 'personeller', label: `Personeller (${personeller.length})` },
    { key: 'kadrolar', label: `Acik Pozisyonlar (${kadrolar.filter(k => k.durum === 'acik').length})` },
    { key: 'kadro-talepleri', label: 'Kadro Talepleri' },
    { key: 'gelir', label: 'Gelir/Maliyet' },
    { key: 'sozlesme', label: 'Sozlesme' },
    { key: 'aktivite', label: 'Aktiviteler' },
  ];

  return (
    <div>
      <button className="btn btn-secondary btn-sm" onClick={geriDon} style={{ marginBottom: '1.5rem' }}>← Listeye Don</button>

      <div className="card" style={{ marginBottom: '1.5rem', padding: '1.25rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <div className="avatar" data-harf={musteri.firma_adi[0]} style={{ width: '56px', height: '56px', fontSize: '18px', flexShrink: 0 }}>{musteri.firma_adi[0]}</div>
          <div style={{ flex: 1 }}>
            <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '2px' }}>{musteri.firma_adi}</h2>
            <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>{musteri.sektor || '-'} {musteri.ulke ? '· ' + musteri.ulke : ''}</p>
            <div style={{ display: 'flex', gap: '12px', fontSize: '12px', color: 'var(--yazi-ikincil)', marginTop: '4px', flexWrap: 'wrap' }}>
              {musteri.sorumlu_ad && <span>Sorumlu: <strong>{musteri.sorumlu_ad}</strong></span>}
              {musteri.satis_temsilcisi_ad && <span>Satis: <strong>{musteri.satis_temsilcisi_ad}</strong></span>}
            </div>
          </div>
          <span className={'badge ' + (musteri.durum === 'aktif' ? 'badge-tamamlandi' : 'badge-hata')}>{musteri.durum === 'aktif' ? 'Aktif' : 'Pasif'}</span>
        </div>
      </div>

      <div className="stats-grid" style={{ marginBottom: '1.5rem' }}>
        <div className="stat-kart"><div className="stat-sayi" style={{ color: 'var(--mavi)' }}>{personeller.length}</div><div className="stat-etiket">Personel</div></div>
        <div className="stat-kart"><div className="stat-sayi" style={{ color: 'var(--sari)' }}>{kadrolar.filter(k=>k.durum==='acik').length}</div><div className="stat-etiket">Acik Kadro</div></div>
        <div className="stat-kart"><div className="stat-sayi" style={{ color: 'var(--yesil)', fontSize: '14px' }}>{fmtPara(toplamGelir, musteri.para_birimi)}</div><div className="stat-etiket">Toplam Gelir</div></div>
      </div>

      <div style={{ display: 'flex', borderBottom: '1px solid var(--border)', marginBottom: '1.5rem', overflowX: 'auto' }}>
        {sekmeler.map(s => (
          <button key={s.key} onClick={() => { setSekme(s.key); setSonuc(null); setDuzenle(false); }}
            style={{ padding: '0.6rem 1.25rem', border: 'none', background: 'none', cursor: 'pointer', fontSize: '13px', whiteSpace: 'nowrap', fontWeight: sekme === s.key ? '600' : '400', color: sekme === s.key ? 'var(--mavi)' : 'var(--yazi-ikincil)', borderBottom: sekme === s.key ? '2px solid var(--mavi)' : '2px solid transparent' }}>
            {s.label}
          </button>
        ))}
      </div>

      {sonuc && <div className={'alert alert-' + (sonuc.tip === 'basari' ? 'success' : 'error')} style={{ marginBottom: '1rem' }}>{sonuc.mesaj}</div>}

      {sekme === 'bilgiler' && (
        <div className="card">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border)' }}>
            <h3 style={{ fontSize: '16px', fontWeight: '600' }}>Musteri Bilgileri</h3>
            {!duzenle && <button className="btn btn-secondary" onClick={() => setDuzenle(true)}>Duzenle</button>}
          </div>
          {!duzenle ? (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
              {[
                { label: 'Firma Adi', value: musteri.firma_adi },
                { label: 'Sektor', value: musteri.sektor },
                { label: 'Musteri Turu', value: musteri.musteri_turu },
                { label: 'Ulke', value: musteri.ulke },
                { label: 'Yetkili Kisi', value: musteri.yetkili_ad },
                { label: 'Yetkili Telefon', value: musteri.yetkili_telefon },
                { label: 'Yetkili E-posta', value: musteri.yetkili_email },
                { label: 'Adres', value: musteri.adres },
                { label: 'Sorumlu', value: musteri.sorumlu_ad },
                { label: 'Satis Temsilcisi', value: musteri.satis_temsilcisi_ad },
                { label: 'Para Birimi', value: musteri.para_birimi },
                { label: 'Potansiyel Deger', value: musteri.potansiyel_deger ? fmtPara(musteri.potansiyel_deger, musteri.para_birimi) : null },
              ].map(item => (
                <div key={item.label} style={{ background: 'var(--gri-50)', borderRadius: 'var(--radius-sm)', padding: '0.6rem 0.75rem' }}>
                  <div style={{ fontSize: '11px', color: 'var(--yazi-ikincil)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '2px' }}>{item.label}</div>
                  <div style={{ fontSize: '13px', fontWeight: '500' }}>{item.value || '-'}</div>
                </div>
              ))}
            </div>
          ) : (
            <form onSubmit={handleKaydet}>
              <div className="form-grid">
                <div className="form-group"><label>Firma Adi *</label><input type="text" value={form.firma_adi || ''} onChange={e => setForm({ ...form, firma_adi: e.target.value })} required /></div>
                <div className="form-group"><label>Sektor</label><input type="text" value={form.sektor || ''} onChange={e => setForm({ ...form, sektor: e.target.value })} /></div>
                <div className="form-group"><label>Musteri Turu</label>
                  <select value={form.musteri_turu || 'outsource'} onChange={e => setForm({ ...form, musteri_turu: e.target.value })}>
                    <option value="outsource">Outsource</option>
                    <option value="proje">Proje Bazli</option>
                    <option value="danismanlik">Danismanlik</option>
                    <option value="diger">Diger</option>
                  </select>
                </div>
                <div className="form-group"><label>Ulke</label><input type="text" value={form.ulke || ''} onChange={e => setForm({ ...form, ulke: e.target.value })} /></div>
                <div className="form-group"><label>Yetkili Kisi</label><input type="text" value={form.yetkili_ad || ''} onChange={e => setForm({ ...form, yetkili_ad: e.target.value })} /></div>
                <div className="form-group"><label>Yetkili Telefon</label><input type="tel" value={form.yetkili_telefon || ''} onChange={e => setForm({ ...form, yetkili_telefon: e.target.value })} /></div>
                <div className="form-group"><label>Yetkili E-posta</label><input type="email" value={form.yetkili_email || ''} onChange={e => setForm({ ...form, yetkili_email: e.target.value })} /></div>
                <div className="form-group full"><label>Adres</label><textarea value={form.adres || ''} onChange={e => setForm({ ...form, adres: e.target.value })} rows={2} /></div>
                <div className="form-group"><label>Sorumlu Kisi</label>
                  <select value={form.sorumlu_kullanici_id || ''} onChange={e => setForm({ ...form, sorumlu_kullanici_id: e.target.value })}>
                    <option value="">-- Secin --</option>
                    {kullanicilar.map(k => <option key={k.id} value={k.id}>{k.ad} {k.soyad}</option>)}
                  </select>
                </div>
                <div className="form-group"><label>Satis Temsilcisi</label>
                  <select value={form.satis_temsilcisi_id || ''} onChange={e => setForm({ ...form, satis_temsilcisi_id: e.target.value })}>
                    <option value="">-- Secin --</option>
                    {kullanicilar.map(k => <option key={k.id} value={k.id}>{k.ad} {k.soyad}</option>)}
                  </select>
                </div>
                <div className="form-group"><label>Para Birimi</label>
                  <select value={form.para_birimi || 'TRY'} onChange={e => setForm({ ...form, para_birimi: e.target.value })}>
                    <option value="TRY">TRY</option><option value="USD">USD</option><option value="EUR">EUR</option><option value="GBP">GBP</option>
                  </select>
                </div>
                <div className="form-group"><label>Potansiyel Deger</label><input type="number" value={form.potansiyel_deger || ''} onChange={e => setForm({ ...form, potansiyel_deger: e.target.value })} /></div>
                <div className="form-group"><label>Durum</label>
                  <select value={form.durum || 'aktif'} onChange={e => setForm({ ...form, durum: e.target.value })}>
                    <option value="aktif">Aktif</option><option value="pasif">Pasif</option>
                  </select>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '8px', marginTop: '1rem' }}>
                <button type="submit" className="btn btn-primary" disabled={yukleniyor}>{yukleniyor ? 'Kaydediliyor...' : 'Kaydet'}</button>
                <button type="button" className="btn btn-secondary" onClick={() => { setDuzenle(false); setForm(musteri); }}>Iptal</button>
              </div>
            </form>
          )}
        </div>
      )}

      {sekme === 'personeller' && (
        <PersonellerSekme musteriId={musteriId} personeller={personeller} yukle={yukle} setSonuc={setSonuc} onPersonelTikla={setSeciliPersonelId} paraBirimi={musteri.para_birimi} />
      )}

      {sekme === 'kadrolar' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '1rem' }}>
            <button className="btn btn-primary" onClick={() => { setKadroPanel(!kadroPanel); setDuzenleKadroId(null); setKadroForm({ pozisyon: '', departman: '', aciklama: '' }); }}>+ Pozisyon Ekle</button>
          </div>
          {kadroPanel && (
            <div className="card" style={{ marginBottom: '1rem' }}>
              <form onSubmit={handleKadroEkle}>
                <div className="form-grid">
                  <div className="form-group"><label>Pozisyon *</label><input type="text" value={kadroForm.pozisyon} onChange={e => setKadroForm({ ...kadroForm, pozisyon: e.target.value })} required /></div>
                  <div className="form-group"><label>Departman</label><input type="text" value={kadroForm.departman} onChange={e => setKadroForm({ ...kadroForm, departman: e.target.value })} /></div>
                  <div className="form-group full"><label>Aciklama</label><textarea value={kadroForm.aciklama} onChange={e => setKadroForm({ ...kadroForm, aciklama: e.target.value })} rows={2} /></div>
                </div>
                <div style={{ display: 'flex', gap: '8px', marginTop: '1rem' }}>
                  <button type="submit" className="btn btn-primary" disabled={yukleniyor}>{duzenleKadroId ? 'Guncelle' : 'Ekle'}</button>
                  <button type="button" className="btn btn-secondary" onClick={() => setKadroPanel(false)}>Iptal</button>
                </div>
              </form>
            </div>
          )}
          <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
            {kadrolar.length === 0 ? (
              <div style={{ padding: '3rem', textAlign: 'center', color: 'var(--yazi-ikincil)' }}>Kadro bulunmuyor.</div>
            ) : (
              <div className="tablo-wrapper">
                <table>
                  <thead><tr><th>Pozisyon</th><th>Departman</th><th>Aciklama</th><th>Durum</th><th>Tarih</th><th></th></tr></thead>
                  <tbody>
                    {kadrolar.map(k => (
                      <tr key={k.id}>
                        <td style={{ fontWeight: '500' }}>{k.pozisyon}</td>
                        <td style={{ fontSize: '13px' }}>{k.departman || '-'}</td>
                        <td style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>{k.aciklama || '-'}</td>
                        <td>
                          <select value={k.durum} onChange={e => handleKadroDurum(k.id, e.target.value)} style={{ fontSize: '12px', padding: '2px 6px', border: '1px solid var(--border)', borderRadius: 'var(--radius-sm)' }}>
                            <option value="acik">Acik</option>
                            <option value="kapali">Kapali</option>
                            <option value="donduruldu">Donduruldu</option>
                          </select>
                        </td>
                        <td style={{ fontSize: '13px' }}>{fmt(k.olusturma_tarihi)}</td>
                        <td>
                          <div style={{ display: 'flex', gap: '4px' }}>
                            <button className="btn btn-secondary btn-sm" onClick={() => { setDuzenleKadroId(k.id); setKadroForm({ pozisyon: k.pozisyon, departman: k.departman || '', aciklama: k.aciklama || '', durum: k.durum }); setKadroPanel(true); }}>Duzenle</button>
                            <button className="btn btn-danger btn-sm" onClick={() => handleKadroSil(k.id)}>Sil</button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      )}

      {sekme === 'kadro-talepleri' && <KadroSekme musteriId={musteriId} />}

      {sekme === 'gelir' && (
        <div>
          <div className="stats-grid" style={{ marginBottom: '1.5rem' }}>
            <div className="stat-kart"><div className="stat-sayi" style={{ color: 'var(--yesil)', fontSize: '14px' }}>{fmtPara(toplamGelir, musteri.para_birimi)}</div><div className="stat-etiket">Toplam Gelir</div></div>
            <div className="stat-kart"><div className="stat-sayi" style={{ color: 'var(--kirmizi)', fontSize: '14px' }}>{fmtPara(toplamMaliyet, musteri.para_birimi)}</div><div className="stat-etiket">Toplam Maliyet</div></div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
            <div style={{ display: 'flex', gap: '6px', background: '#F3F4F6', padding: '4px', borderRadius: '8px' }}>
              {[['tablo','Tablo'],['grafik','Grafik']].map(([k,l]) => (
                <button key={k} onClick={() => setGelirGorunum(k)} style={{ padding: '6px 14px', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px', fontWeight: 600, background: gelirGorunum === k ? '#fff' : 'transparent', color: gelirGorunum === k ? '#111827' : '#6B7280', boxShadow: gelirGorunum === k ? '0 1px 3px rgba(0,0,0,0.1)' : 'none' }}>{l}</button>
              ))}
            </div>
            <button className="btn btn-primary" onClick={() => { setGelirPanel(!gelirPanel); setDuzenleGelirId(null); setGelirForm({ donem: '', gelir: '', maliyet: '', aciklama: '' }); }}>+ Quarter Ekle</button>
          </div>
          {gelirPanel && (
            <div className="card" style={{ marginBottom: '1rem', borderLeft: `4px solid ${duzenleGelirId ? '#F59E0B' : 'var(--yesil)'}` }}>
              <h3 style={{ fontSize: '15px', fontWeight: 600, marginBottom: '1rem' }}>{duzenleGelirId ? 'Donem Duzenle' : '+ Quarter Gelir/Maliyet Ekle'}</h3>
              <form onSubmit={handleGelirEkle}>
                <div className="form-grid">
                  <div className="form-group">
                    <label>Ay *</label>
                    <select value={gelirForm.ay} onChange={e => setGelirForm({ ...gelirForm, ay: e.target.value })} required>
                      <option value="">-- Ay secin --</option>
                      {AY_LISTESI().map(a => <option key={a.value} value={a.value}>{a.label}</option>)}
                    </select>
                  </div>
                  <div className="form-group"><label>Gelir ({musteri.para_birimi})</label><input type="number" value={gelirForm.gelir} onChange={e => setGelirForm({ ...gelirForm, gelir: e.target.value })} placeholder="0" /></div>
                  <div className="form-group"><label>Maliyet ({musteri.para_birimi})</label><input type="number" value={gelirForm.maliyet} onChange={e => setGelirForm({ ...gelirForm, maliyet: e.target.value })} placeholder="0" /></div>
                  <div className="form-group"><label>Aciklama</label><input type="text" value={gelirForm.aciklama} onChange={e => setGelirForm({ ...gelirForm, aciklama: e.target.value })} /></div>
                </div>
                <div style={{ display: 'flex', gap: '8px', marginTop: '1rem' }}>
                  <button type="submit" className="btn btn-primary" disabled={yukleniyor}>{yukleniyor ? 'Kaydediliyor...' : duzenleGelirId ? 'Guncelle' : 'Kaydet'}</button>
                  <button type="button" className="btn btn-secondary" onClick={() => { setGelirPanel(false); setDuzenleGelirId(null); }}>Iptal</button>
                </div>
              </form>
            </div>
          )}
          {gelirGorunum === 'grafik' && gelirler.length > 0 && (
            <div className="card" style={{ marginBottom: '1rem', padding: '1.5rem' }}>
              <div style={{ overflowX: 'auto' }}>
                <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-end', minWidth: `${gelirler.length * 100}px`, height: '200px', padding: '0 8px' }}>
                  {[...gelirler].reverse().map(g => {
                    const net = (g.gelir || 0) - (g.maliyet || 0);
                    const maxVal = Math.max(...gelirler.map(x => x.gelir || 0));
                    const gelirH = maxVal > 0 ? Math.round(((g.gelir || 0) / maxVal) * 160) : 0;
                    const maliyetH = maxVal > 0 ? Math.round(((g.maliyet || 0) / maxVal) * 160) : 0;
                    return (
                      <div key={g.id} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px', flex: 1, minWidth: '80px' }}>
                        <div style={{ fontSize: '10px', color: net >= 0 ? 'var(--yesil)' : 'var(--kirmizi)', fontWeight: 700 }}>{net >= 0 ? '+' : ''}{Math.round(net/1000)}K</div>
                        <div style={{ display: 'flex', gap: '4px', alignItems: 'flex-end', height: '160px' }}>
                          <div style={{ width: '24px', height: `${gelirH}px`, background: 'var(--yesil)', borderRadius: '4px 4px 0 0', minHeight: '4px' }} />
                          <div style={{ width: '24px', height: `${maliyetH}px`, background: 'var(--kirmizi)', borderRadius: '4px 4px 0 0', minHeight: '4px', opacity: 0.7 }} />
                        </div>
                        <div style={{ fontSize: '11px', fontWeight: 700, color: '#374151', textAlign: 'center' }}>{g.donem}</div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          )}
          {gelirGorunum === 'tablo' && (
            <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
              <div style={{ padding: '10px 16px', borderBottom: '1px solid var(--border)', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                <select value={filtreQuarter} onChange={e => setFiltreQuarter(e.target.value)} style={{ width: 'auto', fontSize: '13px' }}>
                  <option value="">Tum Quarterlar</option>
                  {QUARTER_LISTESI().map(q => <option key={q.value} value={q.value}>{q.label}</option>)}
                </select>
                <select value={filtreAy} onChange={e => setFiltreAy(e.target.value)} style={{ width: 'auto', fontSize: '13px' }}>
                  <option value="">Tum Aylar</option>
                  {AY_LISTESI().map(a => <option key={a.value} value={a.value}>{a.label}</option>)}
                </select>
                {(filtreQuarter || filtreAy) && (
                  <button onClick={() => { setFiltreQuarter(''); setFiltreAy(''); }} style={{ fontSize: '12px', padding: '4px 10px', border: '1px solid var(--border)', borderRadius: '6px', cursor: 'pointer', background: '#fff' }}>Temizle</button>
                )}
              </div>
              {gelirler.length === 0 ? (
                <div style={{ padding: '3rem', textAlign: 'center', color: 'var(--yazi-ikincil)' }}>Henuz gelir kaydi yok.</div>
              ) : (
                <div className="tablo-wrapper">
                  <table>
                    <thead><tr><th>Ay</th><th>Quarter</th><th>Gelir</th><th>Maliyet</th><th>Aciklama</th><th></th></tr></thead>
                    <tbody>
                      {gelirler.filter(g => {
                        if (filtreQuarter && g.quarter !== filtreQuarter) return false;
                        if (filtreAy && (g.ay || g.donem) !== filtreAy) return false;
                        return true;
                      }).map(g => {
                        const ayAdlari = ['','Ocak','Subat','Mart','Nisan','Mayis','Haziran','Temmuz','Agustos','Eylul','Ekim','Kasim','Aralik'];
                        const ayStr = g.ay || g.donem || '';
                        const ayNo = ayStr.includes('-') && !ayStr.includes('Q') ? parseInt(ayStr.split('-')[1]) : null;
                        const ayLabel = ayNo ? `${ayAdlari[ayNo]} ${ayStr.split('-')[0]}` : ayStr;
                        return (
                          <tr key={g.id}>
                            <td style={{ fontWeight: 600, fontSize: '13px' }}>{ayLabel}</td>
                            <td><span style={{ background: '#EEF2FF', color: '#4F46E5', padding: '3px 10px', borderRadius: '99px', fontSize: '12px' }}>{g.quarter || '-'}</span></td>
                            <td style={{ color: 'var(--yesil)', fontWeight: 600 }}>{fmtPara(g.gelir, musteri.para_birimi)}</td>
                            <td style={{ color: 'var(--kirmizi)' }}>{fmtPara(g.maliyet, musteri.para_birimi)}</td>
                            <td style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>{g.aciklama || '-'}</td>
                            <td>
                              <div style={{ display: 'flex', gap: '4px' }}>
                                <button className="btn btn-secondary btn-sm" onClick={() => handleGelirDuzenle(g)}>Duzenle</button>
                                <button className="btn btn-danger btn-sm" onClick={() => handleGelirSil(g.id)}>Sil</button>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}
        </div>
      )}

      {sekme === 'sozlesme' && (
        <div className="card">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border)' }}>
            <h3 style={{ fontSize: '16px', fontWeight: '600' }}>Sozlesme Bilgileri</h3>
            {!duzenle && <button className="btn btn-secondary" onClick={() => setDuzenle(true)}>Duzenle</button>}
          </div>
          {!duzenle ? (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
              {[
                { label: 'Baslangic Tarihi', value: fmt(musteri.sozlesme_baslangic) },
                { label: 'Bitis Tarihi', value: fmt(musteri.sozlesme_bitis) },
                { label: 'Sozlesme Tutari', value: musteri.sozlesme_tutari ? fmtPara(musteri.sozlesme_tutari, musteri.para_birimi) : null },
                { label: 'Notlar', value: musteri.sozlesme_notu },
              ].map(item => (
                <div key={item.label} style={{ background: 'var(--gri-50)', borderRadius: 'var(--radius-sm)', padding: '0.6rem 0.75rem' }}>
                  <div style={{ fontSize: '11px', color: 'var(--yazi-ikincil)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '2px' }}>{item.label}</div>
                  <div style={{ fontSize: '13px', fontWeight: '500' }}>{item.value || '-'}</div>
                </div>
              ))}
            </div>
          ) : (
            <form onSubmit={handleKaydet}>
              <div className="form-grid">
                <div className="form-group"><label>Baslangic Tarihi</label><input type="date" value={form.sozlesme_baslangic || ''} onChange={e => setForm({ ...form, sozlesme_baslangic: e.target.value })} /></div>
                <div className="form-group"><label>Bitis Tarihi</label><input type="date" value={form.sozlesme_bitis || ''} onChange={e => setForm({ ...form, sozlesme_bitis: e.target.value })} /></div>
                <div className="form-group"><label>Sozlesme Tutari</label><input type="number" value={form.sozlesme_tutari || ''} onChange={e => setForm({ ...form, sozlesme_tutari: e.target.value })} /></div>
                <div className="form-group full"><label>Notlar</label><textarea value={form.sozlesme_notu || ''} onChange={e => setForm({ ...form, sozlesme_notu: e.target.value })} rows={3} /></div>
              </div>
              <div style={{ display: 'flex', gap: '8px', marginTop: '1rem' }}>
                <button type="submit" className="btn btn-primary" disabled={yukleniyor}>{yukleniyor ? 'Kaydediliyor...' : 'Kaydet'}</button>
                <button type="button" className="btn btn-secondary" onClick={() => { setDuzenle(false); setForm(musteri); }}>Iptal</button>
              </div>
            </form>
          )}
        </div>
      )}

      {sekme === 'aktivite' && (
        <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
          {aktiviteler.length === 0 ? (
            <div style={{ padding: '3rem', textAlign: 'center', color: 'var(--yazi-ikincil)' }}>Aktivite kaydi bulunamadi.</div>
          ) : (
            <div style={{ padding: '1rem' }}>
              {aktiviteler.map((a, i) => (
                <div key={a.id} style={{ display: 'flex', gap: '12px', paddingBottom: '12px', marginBottom: '12px', borderBottom: i < aktiviteler.length - 1 ? '1px solid var(--border)' : 'none' }}>
                  <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: 'var(--mavi)', marginTop: '6px', flexShrink: 0 }} />
                  <div>
                    <div style={{ fontSize: '13px', fontWeight: 600 }}>{a.aciklama}</div>
                    <div style={{ fontSize: '12px', color: 'var(--yazi-ikincil)', marginTop: '2px' }}>{a.kullanici_ad || 'Sistem'} · {fmt(a.tarih)}</div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const MusterilerPage = () => {
  const [musteriler, setMusteriler] = useState([]);
  const [seciliId, setSeciliId] = useState(null);
  const [yeniPanel, setYeniPanel] = useState(false);
  const [yeniForm, setYeniForm] = useState({ firma_adi: '', sektor: '', yetkili_ad: '', yetkili_telefon: '', yetkili_email: '', musteri_turu: 'outsource' });
  const [arama, setArama] = useState('');
  const [filtreDurum, setFiltreDurum] = useState('aktif');
  const [sonuc, setSonuc] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(false);

  const yukle = () => axios.get('/api/musteriler').then(r => setMusteriler(r.data)).catch(console.error);
  useEffect(() => { yukle(); }, []);

  if (seciliId) return <MusteriDetay musteriId={seciliId} geriDon={() => { setSeciliId(null); yukle(); }} />;

  const handleYeniKaydet = async (e) => {
    e.preventDefault(); setYukleniyor(true); setSonuc(null);
    try {
      await axios.post('/api/musteriler', yeniForm);
      setSonuc({ tip: 'basari', mesaj: 'Musteri eklendi.' });
      setYeniForm({ firma_adi: '', sektor: '', yetkili_ad: '', yetkili_telefon: '', yetkili_email: '', musteri_turu: 'outsource' });
      setYeniPanel(false); yukle();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata olustu.' }); }
    finally { setYukleniyor(false); }
  };

  const filtrelenmis = musteriler.filter(m => {
    const aramaUyum = (m.firma_adi + ' ' + (m.sektor || '') + ' ' + (m.yetkili_ad || '') + ' ' + (m.sorumlu_ad || '') + ' ' + (m.satis_temsilcisi_ad || '')).toLowerCase().includes(arama.toLowerCase());
    const durumUyum = !filtreDurum || m.durum === filtreDurum;
    return aramaUyum && durumUyum;
  });

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '1rem', marginBottom: '1.5rem' }}>
        <div>
          <h2 style={{ fontSize: '22px', marginBottom: '4px' }}>Musteriler</h2>
          <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>Musteri firmalarini ve satis portfoyunu yonetin.</p>
        </div>
        <button className="btn btn-primary" onClick={() => setYeniPanel(!yeniPanel)}>+ Yeni Musteri</button>
      </div>

      {sonuc && <div className={'alert alert-' + (sonuc.tip === 'basari' ? 'success' : 'error')} style={{ marginBottom: '1rem' }}>{sonuc.mesaj}</div>}

      {yeniPanel && (
        <div className="card" style={{ marginBottom: '1.5rem' }}>
          <h3 style={{ fontSize: '15px', fontWeight: 600, marginBottom: '1rem' }}>Yeni Musteri</h3>
          <form onSubmit={handleYeniKaydet}>
            <div className="form-grid">
              <div className="form-group"><label>Firma Adi *</label><input type="text" value={yeniForm.firma_adi} onChange={e => setYeniForm({ ...yeniForm, firma_adi: e.target.value })} required /></div>
              <div className="form-group"><label>Sektor</label><input type="text" value={yeniForm.sektor} onChange={e => setYeniForm({ ...yeniForm, sektor: e.target.value })} /></div>
              <div className="form-group"><label>Musteri Turu</label>
                <select value={yeniForm.musteri_turu} onChange={e => setYeniForm({ ...yeniForm, musteri_turu: e.target.value })}>
                  <option value="outsource">Outsource</option>
                  <option value="proje">Proje Bazli</option>
                  <option value="danismanlik">Danismanlik</option>
                  <option value="diger">Diger</option>
                </select>
              </div>
              <div className="form-group"><label>Yetkili Kisi</label><input type="text" value={yeniForm.yetkili_ad} onChange={e => setYeniForm({ ...yeniForm, yetkili_ad: e.target.value })} /></div>
              <div className="form-group"><label>Yetkili Telefon</label><input type="tel" value={yeniForm.yetkili_telefon} onChange={e => setYeniForm({ ...yeniForm, yetkili_telefon: e.target.value })} /></div>
              <div className="form-group"><label>Yetkili E-posta</label><input type="email" value={yeniForm.yetkili_email} onChange={e => setYeniForm({ ...yeniForm, yetkili_email: e.target.value })} /></div>
            </div>
            <div style={{ display: 'flex', gap: '8px', marginTop: '1rem' }}>
              <button type="submit" className="btn btn-primary" disabled={yukleniyor}>{yukleniyor ? 'Kaydediliyor...' : 'Musteri Ekle'}</button>
              <button type="button" className="btn btn-secondary" onClick={() => setYeniPanel(false)}>Iptal</button>
            </div>
          </form>
        </div>
      )}

      <div className="stats-grid" style={{ marginBottom: '1.5rem' }}>
        <div className="stat-kart"><div className="stat-sayi">{musteriler.length}</div><div className="stat-etiket">Toplam</div></div>
        <div className="stat-kart"><div className="stat-sayi" style={{ color: 'var(--yesil)' }}>{musteriler.filter(m => m.durum === 'aktif').length}</div><div className="stat-etiket">Aktif</div></div>
        <div className="stat-kart"><div className="stat-sayi" style={{ color: 'var(--mavi)' }}>{musteriler.reduce((t, m) => t + (m.personel_sayisi || 0), 0)}</div><div className="stat-etiket">Toplam Personel</div></div>
        <div className="stat-kart"><div className="stat-sayi" style={{ color: 'var(--sari)' }}>{musteriler.reduce((t, m) => t + (m.acik_kadro_sayisi || 0), 0)}</div><div className="stat-etiket">Acik Kadro</div></div>
      </div>

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        <div style={{ padding: '1rem 1.25rem', borderBottom: '1px solid var(--border)', display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center' }}>
          <input type="text" placeholder="Firma, sektor, sorumlu ara..." value={arama} onChange={e => setArama(e.target.value)} style={{ flex: 1, minWidth: '200px' }} />
          <select value={filtreDurum} onChange={e => setFiltreDurum(e.target.value)} style={{ width: 'auto' }}>
            <option value="">Tumu</option>
            <option value="aktif">Aktif</option>
            <option value="pasif">Pasif</option>
          </select>
        </div>
        {filtrelenmis.length === 0 ? (
          <div style={{ padding: '3rem', textAlign: 'center', color: 'var(--yazi-ikincil)' }}>Musteri bulunamadi.</div>
        ) : (
          <div className="tablo-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Firma</th><th>Sektor / Tur</th><th>Sorumlu</th><th>Satis Temsilcisi</th><th>Personel</th><th>Acik Kadro</th><th>Durum</th>
                </tr>
              </thead>
              <tbody>
                {filtrelenmis.map(m => (
                  <tr key={m.id} onClick={() => setSeciliId(m.id)} style={{ cursor: 'pointer' }}>
                    <td>
                      <div style={{ fontWeight: '500' }}>{m.firma_adi}</div>
                      {m.ulke && <div style={{ fontSize: '11px', color: 'var(--yazi-ikincil)' }}>{m.ulke}</div>}
                    </td>
                    <td style={{ fontSize: '13px' }}>
                      <div>{m.sektor || '-'}</div>
                      {m.musteri_turu && <div style={{ fontSize: '11px', color: 'var(--yazi-ikincil)' }}>{m.musteri_turu}</div>}
                    </td>
                    <td style={{ fontSize: '13px' }}>{m.sorumlu_ad || '-'}</td>
                    <td style={{ fontSize: '13px' }}>{m.satis_temsilcisi_ad || '-'}</td>
                    <td style={{ fontSize: '13px', textAlign: 'center' }}>{m.personel_sayisi || 0}</td>
                    <td style={{ fontSize: '13px', textAlign: 'center' }}>{m.acik_kadro_sayisi || 0}</td>
                    <td><span className={'badge ' + (m.durum === 'aktif' ? 'badge-tamamlandi' : 'badge-hata')}>{m.durum === 'aktif' ? 'Aktif' : 'Pasif'}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default MusterilerPage;
